import { Phone, User, Loader2 } from 'lucide-react';
import type { EmergencyContact } from '@yawi/types';

interface EmergencyContactsProps {
  contacts: EmergencyContact[];
  loading?: boolean;
}

export const EmergencyContacts = ({ contacts, loading }: EmergencyContactsProps) => {
  if (loading) {
    return (
      <div className="flex items-center justify-center py-8">
        <Loader2 className="w-6 h-6 animate-spin text-primary-500" />
      </div>
    );
  }

  if (contacts.length === 0) {
    return (
      <div className="text-center py-8 text-slate-500">
        <Phone className="w-12 h-12 mx-auto mb-3 opacity-50" />
        <p>No hay contactos de emergencia configurados</p>
      </div>
    );
  }

  // Sort by priority
  const sortedContacts = [...contacts].sort((a, b) => a.priority - b.priority);

  return (
    <div className="space-y-3">
      {sortedContacts.map((contact, index) => (
        <div
          key={contact.id}
          className="flex items-center gap-4 p-4 bg-white rounded-xl border border-slate-200 shadow-sm hover:shadow-md transition-shadow"
        >
          <div className={`
            w-10 h-10 rounded-full flex items-center justify-center font-bold text-white
            ${index === 0 ? 'bg-red-500' : index === 1 ? 'bg-orange-500' : 'bg-slate-400'}
          `}>
            {contact.priority}
          </div>

          <div className="flex-1">
            <div className="flex items-center gap-2">
              <User className="w-4 h-4 text-slate-400" />
              <span className="font-medium text-slate-800">{contact.name}</span>
            </div>
            <p className="text-sm text-slate-500">{contact.role}</p>
          </div>

          <a
            href={`tel:${contact.phone}`}
            className="flex items-center gap-2 px-4 py-2 bg-green-500 hover:bg-green-600 text-white rounded-lg font-medium transition-colors"
          >
            <Phone className="w-5 h-5" />
            <span className="hidden sm:inline">{contact.phone}</span>
          </a>
        </div>
      ))}
    </div>
  );
};
